export default __webpack_public_path__ + "static/media/Standard01.265cdeea.png";